// extracted by mini-css-extract-plugin
export default {"highlight":"highlight_highlight__C1Ja9","error":"highlight_error__mqUsX","errorIcon":"highlight_errorIcon__mHp8i"};